module.exports = __webpack_public_path__ + "media/components/style/Slack_Mark-eed3b6a7515f31d2ab25b1be17109e4d.svg";